/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManagedUserTherapist } from './ManagedUserTherapist';
export type ManagedUserDetails = {
    id: number;
    firstName: string;
    lastName: string;
    title: string | null;
    gender: ManagedUserDetails.gender;
    email: string;
    image: string | null;
    isActive: boolean;
    therapists: Array<ManagedUserTherapist>;
    clientCount: number;
};
export namespace ManagedUserDetails {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

